import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.setupApiUrl;
const xmlMapBuilderStoreModule = {
  state: {
    xmlFolderList: [],
    xmlFileList: [],
    xmlMapperList: [],
    xmlMapperDatarows: [],
    xmlTargetQueryList: [],
    viewFileData: [],
    saveFileData: [],
    xmlMapperLockedList: [],
    xmlFileListSource: [],
    xmlFileListFilter: null,
    xmlTestDBConfigList: [],
    fileListCheck: [],
    dbMapperMoveData: [],
    resultTest: null,
  },
  actions: {
    getXmlMapBuilderQueryFolderList: async ({ commit }) => {
      try {
        const response = await axios.post(`${baseURI}/mapBuilder/folderList`);
        commit('SET_STORE_FOLDER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_FOLDER_LIST', []);
        throw err;
      }
    },
    getXmlMapBuilderQueryFileList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/mapBuilder/fileList`, params);
        commit('SET_STORE_FILE_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_FILE_LIST', []);
        throw err;
      }
    },
    getXmlMapBuilderQueryMapList: async ({ commit }) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/list`);
        commit('SET_STORE_XML_MAP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_XML_MAP_LIST', []);
        throw err;
      }
    },
    getXmlMapBuilderTargetQueryList: async ({ commit }) => {
      try {
        const response = await axios.post(`${baseURI}/targetQuery/list`);
        commit('SET_STORE_XML_TARGET_QUERY_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_XML_TARGET_QUERY_LIST', []);
        throw err;
      }
    },
    getXmlMapperLockedList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/lockedList`, params);
        commit('SET_STORE_XML_MAP_LOCKED_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_XML_MAP_LOCKED_LIST', []);
        throw err;
      }
    },
    deployXmlMapBuilder: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/deploy`, params);
        // console.log(response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    testDBMapBuilderD2D: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/d2dTest`, params);
        console.log(response.data);
        commit('SET_STORE_RESULT_TEST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        commit('SET_STORE_RESULT_TEST', null);
        throw err;
      }
    },
    testDBMapBuilderD2J: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/d2jTest`, params);
        commit('SET_STORE_RESULT_TEST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        commit('SET_STORE_RESULT_TEST', null);
        throw err;
      }
    },
    testDBMapBuilderJ2D: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/j2dTest`, params);
        console.log(response.data);
        commit('SET_STORE_RESULT_TEST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        commit('SET_STORE_RESULT_TEST', null);
        throw err;
      }
    },
    testDBMapBuilderD2F: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/dbMapper/d2fTest`, params);
        console.log(response.data);
        commit('SET_STORE_RESULT_TEST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        commit('SET_STORE_RESULT_TEST', null);
        throw err;
      }
    },
    insertTargetQuery: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/targetQuery/insert`, params);
        // console.log(response.data);
      } catch (err) {
        console.log(ex);
        // alert(err);
        throw err;
      }
    },
    insertXmlMapBuilderFile: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/mapBuilder/fileInsert`, params);
        commit('SET_STORE_FILE_LIST', response.data);
        return response.data;
      } catch (err) {
        // alert(err);
        throw err;
      }
    },
    updateXmlMapBuiderFile: async ({commit}, params) => {
      await axios.post(baseURI + "/mapBuilder/fileUpdate", params).then((response) => {
        // alert(response.data);
        commit('SET_STORE_FILE_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    deleteXmlMapBuiderFile: async ({commit}, params) => {
      await axios.post(baseURI + "/mapBuilder/fileDelete", params).then((response) => {
        // alert(response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    insertXmlMapBuiderFolder: async ({commit}, params) => {
      await axios.post(baseURI + "/mapBuilder/folderInsert", params).then((response) => {
        // alert(response.data);
        commit('SET_STORE_FOLDER_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    updateXmlMapBuiderFolder: async ({commit}, params) => {
      await axios.post(baseURI + "/mapBuilder/folderUpdate", params).then((response) => {
        // alert(response.data);
        commit('SET_STORE_FOLDER_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    deleteXmlMapBuiderFolder: async ({commit}, params) => {
      await axios.post(baseURI + "/mapBuilder/folderDelete", params).then((response) => {
        // alert(response.data);
        commit('SET_STORE_FOLDER_LIST', response.data);
      }).catch((ex) => {
        throw ex;
      });
    },
    getXmlTestDBConfigList: async ({ commit }) => {
      try {
        const response = await axios.post(`${baseURI}/dbConfig/testList`);
        commit('SET_STORE_XML_TEST_DB_CONFIG_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_XML_TEST_DB_CONFIG_LIST', []);
        throw err;
      }
    },
    getDBConfigDetail: async ({ commit }) => {
      try {
        const response = await axios.post(`${baseURI}/mapBuilder/folderList`);
        commit('SET_STORE_FOLDER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_FOLDER_LIST', []);
        throw err;
      }
    },
    setFilterMapperLoadFile: async ({ commit }, filter) => {
      commit('SET_MAPPER_FILE_LIST_FILTER', filter);
    },
    setEditXmlMapBuiderFile: async ({ commit }, params) => {
      commit('SET_EDIT_NAME_MAPPER_FILE_LIST', params);
    },
    getFileListToCheck: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/mapBuilder/fileList`, params);
        commit('SET_STORE_FILE_LIST_TO_CHECK', response.data);
      } catch (err) {
        commit('SET_STORE_FILE_LIST_TO_CHECK', []);
        throw err;
      }
    },
    moveFile: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/mapBuilder/fileMove`, params);
      } catch (err) {
        throw err;
      }
    },
    getDBMapperMoveData: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${baseURI}/dbMapper/detail/${params.dbMapperId}&${params.ver}`);
        commit('SET_STORE_DB_MAPPER_MOVE_DATA', response.data);
      } catch (err) {
        commit('SET_STORE_DB_MAPPER_MOVE_DATA', []);
        throw err;
      }
    },
  },
  mutations: {
    'SET_STORE_FOLDER_LIST' (state, xmlFolderList) {
      state.xmlFolderList = xmlFolderList;
    },
    'SET_STORE_FILE_LIST' (state, xmlFileList) {
      state.xmlFileList = xmlFileList;
      state.xmlFileListSource = xmlFileList;     
    },
    'SET_STORE_XML_MAP_LIST' (state, xmlMapperList) {
      state.xmlMapperList = xmlMapperList;
      state.xmlMapperDatarows = xmlMapperList;   
    },
    'SET_XML_MAPPER_FILTER'(state, params) {
      let locked = params.locked;
      let search = params.search;
      let arrFilter = state.xmlMapperDatarows;
      if (locked != undefined && locked != '') {
        arrFilter = arrFilter.filter((item) => {
          return  item.lock_yn==locked;
        });
      }
      if (search != undefined && search != '') {
        arrFilter = arrFilter.filter((item) => {
          for (const prop in item) {
            if (prop =="file_name" || prop == "lock_yn" || prop == "xml_name" || prop == "upd_dt" || prop == "xml_ver"){
                if (typeof item[prop] == 'string') {
                  let propValue = item[prop].toLowerCase();
                  let queryValue = search.toLowerCase();
                  if (propValue.includes(queryValue)) {
                    return true;
                  }
                } else if (typeof item[prop] == 'number') {
                  let propValue = item[prop].toString().toLowerCase();
                  let queryValue = search.toLowerCase();
                  if (propValue.includes(queryValue)) {
                    return true;
                  }
                }
            }
          }
        });
      }
      state.xmlMapperList = arrFilter;
    },
    'SET_STORE_XML_TARGET_QUERY_LIST' (state, xmlTargetQueryList) {
      state.xmlTargetQueryList = xmlTargetQueryList;      
    },
    'SET_STORE_VIEW_FILE_DATA' (state, viewFileData) {
      state.viewFileData = viewFileData;      
    },
    'SET_STORE_SAVE_FILE_DATA' (state, saveFileData) {
      state.saveFileData = saveFileData;      
    },
    'SET_STORE_XML_MAP_LOCKED_LIST' (state, xmlMapperLockedList) {
      state.xmlMapperLockedList = xmlMapperLockedList;
    },
    'SET_STORE_XML_TEST_DB_CONFIG_LIST' (state, xmlTestDBConfigList) {
      state.xmlTestDBConfigList = xmlTestDBConfigList;
    },
    'SET_MAPPER_FILE_LIST_FILTER' (state, filter) {
      let datarows = state.xmlFileListSource;
      state.xmlFileListFilter = filter;
      let filterBy = state.xmlFileListFilter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
  
          return false;
        });
      }
      state.xmlFileList = listResult;
    },
    'SET_UPDATE_MAPPER_FILE_LIST' (state, params) {
      let datarows = state.xmlFileList;
      let editRow = params;
      for (let i = 0; i < datarows.length; i++) {
        if (datarows[i].FILE_ID == editRow.FILE_ID) {
          datarows[i].SYSSTATUS = editRow.SYSSTATUS;
        }
      }
      state.xmlFileList = datarows;
    },
    'SET_STORE_FILE_LIST_TO_CHECK' (state, fileListCheck) {
      state.fileListCheck = fileListCheck;
    },
    'SET_STORE_DB_MAPPER_MOVE_DATA' (state, dbMapperMoveData) {
      state.dbMapperMoveData = dbMapperMoveData;
    },
    'SET_STORE_RESULT_TEST' (state, resultTest) {
      state.resultTest = resultTest;
    }
  },
  getters: {
    xmlFolderList: state => state.xmlFolderList,
    xmlFileList: state => state.xmlFileList,
    xmlMapperList: state => state.xmlMapperList,
    xmlTargetQueryList: state => state.xmlTargetQueryList,
    viewFileData: state => state.viewFileData,
    saveFileData: state => state.saveFileData,
    xmlMapperLockedList: state => state.xmlMapperLockedList,
    xmlFileListSource: state => state.xmlFileListSource,
    xmlFileListFilter: state => state.xmlFileListFilter,
    xmlTestDBConfigList: state => state.xmlTestDBConfigList,
    fileListCheck: state => state.fileListCheck,
    dbMapperMoveData: state => state.dbMapperMoveData,
    resultTest: state => state.resultTest,
  },
}

export default xmlMapBuilderStoreModule;